import { render, staticRenderFns } from "./CallUpdateNameProject.vue?vue&type=template&id=24778d3c"
import script from "./CallUpdateNameProject.vue?vue&type=script&lang=js"
export * from "./CallUpdateNameProject.vue?vue&type=script&lang=js"
import style0 from "./CallUpdateNameProject.vue?vue&type=style&index=0&id=24778d3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports